import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B02UserManagementPage } from '../b02-user-management/b02-user-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B09SettingPage } from '../b09-setting/b09-setting';

/**
 * Generated class for the B02bUserInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b09b-branch-info',
  templateUrl: 'b09b-branch-info.html',
})
export class B09bBranchInfoPage {
  private todo : FormGroup;
  loading: any;
  Status: any;
  branchData = {BRANCH_NAME:'',
                ADDR1:'', ADDR2:'', ADDR3:'',
                CONTACT_NO: '', EMAIL:'', PIC:'',
                BRANCH_ACTIVE:'YES',            
              }
  BRANCH_ID:any;
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder,
              private toastCtrl: ToastController, public loadingCtrl: LoadingController,
              public serviceapi: ServiceApiProvider, public alertCtrl : AlertController) {

    this.todo = this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      postCode: ['', Validators.required],
      state: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      pic: ['', Validators.required],
      active: ['', Validators.required],
    });

    this.BRANCH_ID = this.navParams.get('paramID');    //corporate ID

    let tbl = ["BRANCH"];
    let column = ["BRANCH_ID"];
    let value = [this.BRANCH_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
        this.loading.dismiss();

        let Records = result["Records"];
        this.branchData.BRANCH_NAME = Records[0]["BRANCH_NAME"];
        this.branchData.ADDR1 = Records[0]["ADDR1"];
        this.branchData.ADDR2 = Records[0]["ADDR2"];
        this.branchData.ADDR3 = Records[0]["ADDR3"];
        this.branchData.CONTACT_NO = Records[0]["CONTACT_NO"];
        this.branchData.EMAIL = Records[0]["EMAIL"];
        this.branchData.PIC = Records[0]["PIC"];
        this.branchData.BRANCH_ACTIVE = Records[0]["BRANCH_ACTIVE"];
        console.log(this.branchData);

      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02bCompanyInfoPage');
  }

  

  updateUser(){
    this.serviceapi.updatedata('BRANCH', 'BRANCH_ID', this.BRANCH_ID, this.branchData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B09SettingPage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  goToUser(){
    this.navCtrl.setRoot(B09SettingPage);
  }
  
  goTo(){
    this.navCtrl.setRoot(B09SettingPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b09b-branch-info/b09b-branch-info.ts